import { render, staticRenderFns } from "./ksgl-app type.vue?vue&type=template&id=6d69f3b8&scoped=true"
import script from "./ksgl-app type.vue?vue&type=script&lang=js"
export * from "./ksgl-app type.vue?vue&type=script&lang=js"
import style0 from "../../views/matrix-page/assets/css/base.css?vue&type=style&index=0&id=6d69f3b8&prod&scoped=true&lang=css&external"
import style1 from "./ksgl-app type.vue?vue&type=style&index=1&id=6d69f3b8&prod&scoped=true&lang=css"
import style2 from "./ksgl-app type.vue?vue&type=style&index=2&id=6d69f3b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d69f3b8",
  null
  
)

export default component.exports